import React, { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { connect } from "react-redux"
// MODULES
import { Modal } from "antd"
import { join } from "lodash"
import { Check as ICON_CHECK, ChevronRight } from "react-feather"
//
import API from "../../../../api"
import { ROUTES } from "../../../../routes"
import { mapDispatchProps, mapStateToProps } from "../../../../store/store"
// Hooks
import useInfiniteScroll from "../../../../hooks/useInfiniteScroll"
// Helpers
import { isEmpty } from "../../../../helpers/object"
import { debounce } from "../../../../helpers/debounce"
// Components
import Paginator from "../../../../components/paginator"
import Button from "../../../../components/button"
import { useLanguage } from "@languages/index"

const language = useLanguage()
const languageTexts = { ...language.common, ...language.pages.rental }

const AmbassadorPreview = (props: any) => {
  const navigate = useNavigate()
  const [urlSearchParams, setUrlSearchParams] = useSearchParams()

  const [isAmbassadorAvailable, setIsAmbassadorAvailable] = useState(false)
  const [isFetchingBrand, setIsFetchingBrand] = useState(true)
  const [totalApplicantsCount, setTotalApplicantsCount] = useState()
  const [shouldShowIntroduceModal, setShouldShowIntroduceModal] = useState(false)

  const fetchBrand = async () => {
    const brandToken = urlSearchParams.get("brand_token")
    await API.Brand.show({ brandToken })
      .then((response) => {
        props.setBrand(response.data.brand)
      })
      .catch((error) => {
        // DO NOTHING
      })
      .finally(() => {
        if (isFetchingBrand) {
          setIsFetchingBrand(false)
        }
      })
  }

  useEffect(() => {
    if (props?.user?.id != null) {
      navigate(ROUTES.RENTAL_AMBASSADOR_INDEX.PATH)
      return
    }

    fetchBrand()
  }, [urlSearchParams])

  if (props.brand == null || props.brand.isShow !== 1) return <div></div>

  if (props.brand.isAmbassadorServiceEnabled !== 1)
    return <ErrorPage message={languageTexts.ambassador_preview_text_1} />

  if (props.brand.rentableUserTypeFl == null || !props.brand.rentableUserTypeFl.includes("22"))
    return <ErrorPage message={languageTexts.ambassador_preview_text_2} />

  return (
    <div className="py-[70px] px-[20px] select-none">
      {/* 상단 헤더 보이는 조건이 좀 특이한데 (totalApplicantsCount),
       * 최소 작업을 위해 <AmbassadorApplicantsSection />을 활용해서 그렇다.
       * 따로 로드되면 이상해서.. 최적화하려면 해도 됨
       */}
      {totalApplicantsCount != null && (
        <div>
          {props?.brand?.name != null && (
            <div className="text-center text-[17px] font-bold text-[#FF0099]">{props.brand.name}</div>
          )}
          {totalApplicantsCount != null && (
            <div className="mt-[30px] text-center font-bold">
              <div className="text-[22px]">{languageTexts.ambassador_preview_text_3}</div>
              <div className="text-[32px]">{languageTexts._num_of_person(totalApplicantsCount)}</div>
            </div>
          )}
          <div className="mt-[30px] text-center text-[17px]">{languageTexts._ambassador_preview_text_4()}</div>

          <button
            type="button"
            className="w-full mt-[60px] p-[15px] flex flex-row justify-between border border-[#E8E8E8] cursor-pointer select-none"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setShouldShowIntroduceModal(true)
            }}
          >
            <span className="text-[14px]">{languageTexts.ambassador_preview_text_5}</span>
            <ChevronRight className="w-[16px] h-[16px]" />
          </button>
        </div>
      )}

      <AmbassadorApplicantsSection
        {...{
          ...props,
          ...{ auth: { token: urlSearchParams.get("brand_token") } },
        }}
        fetchBrand={fetchBrand}
        totalApplicantsCount={totalApplicantsCount}
        setTotalApplicantsCount={setTotalApplicantsCount}
      />
      <AmbassadorIntroduceModal
        shouldShowModal={shouldShowIntroduceModal}
        closeModal={() => {
          setShouldShowIntroduceModal(false)
        }}
      />
    </div>
  )
}

const ErrorPage = (props) => {
  if (props.message == null) return null
  return (
    <div className="mx-auto mt-20 text-center text-xl font-bold whitespace-pre-wrap break-keep">{props.message}</div>
  )
}

const AmbassadorIntroduceModal = (props) => {
  const headerClass = "text-center text-[17px] font-bold"
  const contentClass = "text-[14px] whitespace-pre-wrap"
  return (
    <Modal
      className="squared-antd-modal"
      style={{ padding: "40px 20px 40px 20px" }}
      centered={true}
      open={props.shouldShowModal}
      onOk={props.closeModal}
      onCancel={props.closeModal}
      footer={null}
      closable={false}
      zIndex={1010}
      width={400}
    >
      <div className="flex flex-col justify-center gap-[50px] p-[20px] pt-[50px]">
        <div className="text-center leading-tight font-bold text-[22px]">
          {languageTexts._ambassador_preview_text_6()}
        </div>

        {...[
          {
            title: languageTexts.ambassador_preview_text_5,
            renderFigure: () => (
              <img
                className="w-[70%] mx-auto"
                alt="preview_01"
                src={"/assets/images/rental/ambassador-preview/preview-image-01.png"}
              />
            ),
            content: languageTexts.ambassador_preview_text_7,
          },
          {
            title: languageTexts.ambassador_preview_text_8,
            renderFigure: () => (
              <img
                className="w-[50%] mx-auto"
                alt="preview_02"
                src={"/assets/images/rental/ambassador-preview/preview-image-02.png"}
              />
            ),
            content: languageTexts.ambassador_preview_text_9,
          },
          {
            title: languageTexts._ambassador_preview_text_10(props.settings.currencyText),
            renderFigure: () => (
              <img
                className="w-[75%] mx-auto"
                alt="preview_03"
                src={"/assets/images/rental/ambassador-preview/preview-image-03.png"}
              />
            ),
            content: languageTexts._ambassador_preview_text_11(props.settings.currencyText),
          },
        ].map(({ title, renderFigure, content }, i) => {
          return (
            <div key={i} className="flex flex-col gap-[15px]">
              <div className={headerClass}>{title}</div>
              <div>{renderFigure()}</div>
              <div className={contentClass}>{content}</div>
            </div>
          )
        })}

        <div className="buttons flex flex-col rows-2 gap-1.5">
          <Button
            className={"min-w-[10rem] py-3 flex justify-center text-center text-base"}
            textColor={"WHITE"}
            buttonColor={"BLACK"}
            text={languageTexts.confirm}
            onClick={() => {
              props.closeModal()
            }}
          />
        </div>
      </div>
    </Modal>
  )
}

const AmbassadorApplicantsSection = (props) => {
  const { fetchBrand } = props
  const [applicants, setApplicants] = useState<any>(undefined)
  const [currentPage, setCurrentPage] = useState<any>(1)
  const [paginator, setPaginator] = useState<any>()
  const [isFetching, setIsFetching, isEnded, setIsEnded] = useInfiniteScroll(async () => {
    // if (isFetching || !applicants.length) {
    //   return false;
    // }
    // if (currentPage.current <= 1) {
    //   return false;
    // }
    // await fetchApplicants();
  })

  const fetchApplicants = async (config?) => {
    if (isEnded && !config.refresh) {
      return false
    }

    setIsFetching(true)
    setApplicants([])

    let targetPage = config?.page ? config.page : currentPage
    if (config?.refresh) targetPage = 1

    const params = {
      brandToken: props.auth.token,
      status: "APPLIED", // 'APPLIED'|'APPROVED'
      page: targetPage,
      with: join(["likes"], ","),
      orderColumn: "created_at",
      orderValue: "desc",
      size: 50,
    }

    await API.Ambassador.index(params)
      .then((response) => {
        const _paginator = response.data.paginator
        setApplicants(() => {
          return response.data.applicants
        })

        setIsEnded(_paginator.currentPage >= _paginator.lastPage)
        setPaginator(_paginator)
        setIsFetching(false)

        setCurrentPage(targetPage)
        props.setTotalApplicantsCount(_paginator.total)
      })
      .catch((error) => {
        props.showModal({ text: error.message })
      })
  }

  useEffect(() => {
    if (props?.auth?.token == null) return
    fetchApplicants()
  }, [props?.auth?.token])

  return (
    <div className="flex flex-col">
      <CampaignApplicantsList
        {...props}
        isFetching={isFetching}
        applicants={applicants}
        setApplicants={setApplicants}
        totalApplicantsCount={props.totalApplicantsCount}
      />

      <LoadingIndicator {...props} isFetching={isFetching} />

      {paginator ? (
        <Paginator
          currentPage={currentPage}
          lastPage={paginator.lastPage}
          onPageChange={(page) => {
            fetchApplicants({ page: page })
          }}
        />
      ) : null}
    </div>
  )
}

const CampaignApplicantsList = (props) => {
  const { applicants, totalApplicantsCount, setApplicants, isFetching } = props

  if (isFetching || applicants === undefined || totalApplicantsCount == undefined) {
    return null
    // return (
    //   <div className="flex flex-row justify-center text-center my-[80px]">
    //     <span className="prose prose-xl text-slate-400">
    //       불러오는 중입니다...
    //     </span>
    //   </div>
    // );
  }

  if (applicants && !applicants.length && !isFetching) {
    let text = languageTexts._ambassador_preview_text_12(totalApplicantsCount)

    if (totalApplicantsCount == 0 && !isFetching) {
      text = languageTexts.ambassador_preview_text_13
    }

    return (
      <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
        <span className="font-bold text-sm tracking-tighter">{`${text}`}</span>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 my-6 gap-y-8 gap-x-4">
      {applicants.map((application, index) => {
        return (
          <MinifiedModelCard
            {...props}
            key={`applicant-model-card-${application.id}-${index}`}
            application={application}
            onLike={(userId: number, result: any) => {
              const applicant = [...props.applicants].map((item) =>
                item.userId == userId
                  ? {
                      ...item,
                      ...{
                        likes: result ? [true] : [],
                      },
                    }
                  : item
              )

              setApplicants(applicant)
            }}
          />
        )
      })}
    </div>
  )
}

const MinifiedModelCard = (props) => {
  function openLink(url) {
    var useragt = navigator.userAgent.toLowerCase()

    if (useragt.match(/kakaotalk/i)) {
      location.href = "kakaotalk://web/openExternal?url=" + encodeURIComponent(url)
    } else if (useragt.match(/line/i)) {
      if (url.indexOf("?") !== -1) {
        location.href = url + "&openExternalBrowser=1"
      } else {
        location.href = url + "?openExternalBrowser=1"
      }
    } else {
      window.open(url, "_blank")
    }
  }

  return (
    <div className="flex flex-col">
      <div className="model-card flex flex-col p-[10px] border rounded box-border border-gray-200">
        <div className="relative flex flex-col">
          <div className="spacer w-full aspect-square" onClick={props.onClick && props.onClick}>
            {props.application.user.profileBackgroundUrl ? (
              <img
                className="w-full h-full object-cover aspect-square"
                src={`${props.application.user.profileBackgroundUrl}`}
                draggable={false}
              />
            ) : (
              <div className="w-full h-full flex justify-center items-center bg-[black]/[.1]">
                <span className="text-sm w-36 text-center justify-center flex text-gray-400 tracking-tighter">
                  {languageTexts.ambassador_preview_text_14}
                </span>
              </div>
            )}
          </div>
          <div className="absolute right-0 bottom-[-24px]" onClick={props.onClick && props.onClick}>
            <div className="border-white border-2 rounded-full overflow-hidden">
              <img className="w-[48px] h-[48px] rounded-full" src={`${props.application.user.profileImageUrl}`} />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-1 mt-[22px]">
          <div className="flex flex-row items-center justify-center">
            <span className="text-[17px] font-bold tracking-tighter">{props.application.user.username}</span>
          </div>

          <div className="flex flex-col py-3">
            <table className="table-fixed border-collapse text-[14px] tracking-tighter">
              <tbody>
                <tr>
                  <td className="w-1/2 py-2">
                    <div className="flex flex-col items-center gap-[3px]">
                      <span>{languageTexts.like}</span>
                      <span>
                        <b>{props.application.likesAverage ? props.application.likesAverage.toLocaleString() : "0"}</b>
                      </span>
                    </div>
                  </td>
                  <td className="w-1/2 py-2">
                    <div className="flex flex-col items-center gap-[3px]">
                      <span>{languageTexts.followers}</span>
                      <span>
                        <b>{props.application.followers ? props.application.followers.toLocaleString() : "0"}</b>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="flex flex-row mt-[16px]">
            <Button
              className={"flex flex-row gap-[8px] py-3 text-center justify-center"}
              buttonColor={"WHITE"}
              textColor={"BLACK"}
              textClassName="text-[14px] tracking-tighter font-bold"
              text={languageTexts.instagram}
              icon={{
                position: "centerLeft",
                icon: (
                  <div className="self-center text-black ml-0.5 mr-0.5">
                    <img className="w-[22px] h-[22px] cursor-pointer" src={`/assets/icons/ic-instagram-sm.svg`} />
                  </div>
                ),
              }}
              onClick={() => {
                openLink(`https://instagram.com/${props.application.user.userModel.instaUserId}${props?.brand?.isCategoryBeauty ? "reels/" : ""}`)
              }}
            />
          </div>
          <div className="flex flex-row">
            <Button
              className={"flex flex-row py-3 text-center justify-center"}
              buttonColor={props.application.likes && props.application.likes.length ? "WHITE" : "BLACK"}
              textColor={props.application.likes && props.application.likes.length ? "BLACK" : "WHITE"}
              textClassName="text-[14px] tracking-tighter font-bold"
              text={
                props.application.likes && props.application.likes.length
                  ? languageTexts.ambassador_preview_text_15
                  : languageTexts.ambassador_preview_text_16
              }
              icon={
                props.application.likes && props.application.likes.length
                  ? {
                      position: "centerRight",
                      icon: (
                        <div className="self-center text-white ml-0.5">
                          <ICON_CHECK
                            size={16}
                            color={props.application.likes && props.application.likes.length ? "BLACK" : "WHITE"}
                            style={{ strokeWidth: "2.5px" }}
                          />
                        </div>
                      ),
                    }
                  : null
              }
              onClick={() => {
                API.Like.store({
                  brandToken: props.auth.token,
                  subject: "Users",
                  subjectId: props.application.userId,
                })
                  .then((response) => {
                    props.onLike ? props.onLike(props.application.userId, response.data.result) : null
                  })
                  .catch((error) => {
                    props.showModal({ text: error.message })
                  })
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

const LoadingIndicator = (props) => {
  if (!props.isFetching) return null

  return (
    <div className="flex flex-col">
      <div className="flex flex-row mx-10 my-10 justify-center items-center">
        <div className="flex flex-row justify-center text-center my-5">
          <span className="prose prose-xl text-slate-400">{languageTexts.loading_1}</span>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(AmbassadorPreview)
